<template>
  <div class="user-role-container">
    <div class="user-role-title">请选择你的身份</div>
    <div class="user-role-tips">便于我们为你提供最佳服务</div>
    <user-card userType="user" />
    <user-card userType="engineer" />
  </div>
</template>

<script>
import UserCard from './UserCard/UserCard.vue';
export default _extend({
  name: 'UserRole',
  components: {
    UserCard
  }
});
</script>

<style lang="scss">
@import './UserRole';
</style>



// WEBPACK FOOTER //
// src/business/views/UserRole/UserRole.vue